import length from 'ramda/src/length'
import path from 'ramda/src/path'
import gt from 'ramda/src/gt'
import pushRouteClient from 'root/src/client/logic/route/util/pushRouteClient'

export default (
	moduleKey, fieldPath, maxItems, action, isMulti, onExit, element,
) => (value) => {
	const redirect = path([0, 'redirect'], value)
	const validateMaxValue = isMulti ? [...value] : value
	if (redirect) {
		const { routeId, routeParams } = redirect
		pushRouteClient({ routeId, routeParams	})
	}
	action(validateMaxValue, moduleKey, fieldPath, onExit, element)

	if (gt(length(value), maxItems)) {
		validateMaxValue.pop()
	}
}
